import { IApplicationState } from '../../types/redux';

export const selectModalContent = (state: IApplicationState) => state.modal.content;
